(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const maxFileSize = 10485760;

    const setMessage = (messageBox, message) => {
      if (!messageBox) return;
      messageBox.textContent = message;
      messageBox.hidden = false;
      messageBox.focus();
    };

    const clearMessage = (messageBox) => {
      if (!messageBox) return;
      messageBox.textContent = "";
      messageBox.hidden = true;
    };

    const setLoading = (form, button, isLoading) => {
      form.toggleAttribute("aria-busy", isLoading);
      if (button) button.disabled = isLoading;
    };

    const removeUploadedFileUrl = (form) => {
      form.querySelectorAll("[data-contact-uploaded-file]").forEach((input) => input.remove());
      delete form.dataset.contactFileUploaded;
    };

    const submitWithCaptcha = (form, submitButton) => {
      if (typeof form.requestSubmit === "function") {
        if (submitButton) {
          form.requestSubmit(submitButton);
        } else {
          form.requestSubmit();
        }
        return;
      }

      if (submitButton) {
        submitButton.click();
        return;
      }

      const fallbackSubmit = document.createElement("button");
      fallbackSubmit.type = "submit";
      fallbackSubmit.hidden = true;
      form.appendChild(fallbackSubmit);
      fallbackSubmit.click();
      fallbackSubmit.remove();
    };

    const initContactUpload = (section) => {
      const form = section.querySelector(".sfny-contact-form");
      const fileInput = section.querySelector("[data-contact-file]");
      const messageBox = section.querySelector("[data-contact-upload-error]");
      const submitButton = section.querySelector(".sfny-contact-form__button");

      if (!form || !fileInput || fileInput.dataset.uploadInitialized === "true") return;

      fileInput.dataset.uploadInitialized = "true";

      fileInput.addEventListener("change", () => {
        clearMessage(messageBox);
        removeUploadedFileUrl(form);
        fileInput.disabled = false;
        const file = fileInput.files && fileInput.files[0];

        if (file && file.size > maxFileSize) {
          fileInput.value = "";
          setMessage(messageBox, section.dataset.fileSizeError);
        }
      });

      form.addEventListener("submit", (event) => {
        if (form.dataset.contactFileUploaded === "true") return;

        const file = fileInput.files && fileInput.files[0];

        if (!file) return;

        if (file.size > maxFileSize) {
          event.preventDefault();
          event.stopImmediatePropagation();
          fileInput.value = "";
          setMessage(messageBox, section.dataset.fileSizeError);
          return;
        }

        const proxyPath = window.EComposer && window.EComposer.proxy_path;

        if (!proxyPath) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setMessage(messageBox, section.dataset.fileProxyError);
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        clearMessage(messageBox);
        setLoading(form, submitButton, true);

        const formData = new FormData();
        formData.append("file", file);

        fetch(`${window.location.origin}${proxyPath}/contact-form`, {
          method: "POST",
          body: formData
        })
          .then((response) => response.json())
          .then((payload) => {
            if (payload.status === "success" && payload.src_file) {
              const fileUrl = document.createElement("input");
              fileUrl.type = "hidden";
              fileUrl.name = fileInput.name;
              fileUrl.value = payload.src_file;
              fileUrl.dataset.contactUploadedFile = "true";
              form.dataset.contactFileUploaded = "true";
              fileInput.disabled = true;
              form.appendChild(fileUrl);
              setLoading(form, submitButton, false);
              submitWithCaptcha(form, submitButton);
              return;
            }

            throw new Error(payload.message || section.dataset.fileUploadError);
          })
          .catch((error) => {
            console.error(error);
            setMessage(messageBox, error.message || section.dataset.fileUploadError);
            setLoading(form, submitButton, false);
          });
      });
    };

    document.querySelectorAll(".sfny-contact").forEach(initContactUpload);

    document.addEventListener("shopify:section:load", (event) => {
      const section = event.target.matches(".sfny-contact") ? event.target : event.target.querySelector(".sfny-contact");
      if (section) initContactUpload(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-hover-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia("(max-width: 749px)");
    const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const isDesignMode = window.Shopify && window.Shopify.designMode;

    if (!isDesignMode) {
      document.documentElement.classList.add("sfny-founder-story-enhanced");
    }

    const updateHash = (target) => {
      if (!target.id || !window.history || !window.history.pushState) return;
      window.history.pushState(null, "", "#" + target.id);
    };

    const getStoryTargetId = (card) => {
      const dataTarget = card.dataset.storyTarget || "";
      if (dataTarget) return dataTarget.replace(/^#/, "");

      const href = card.getAttribute("href") || "";
      if (href.charAt(0) === "#") return href.slice(1);

      return "";
    };

    const findStoryTarget = (targetId) => {
      if (!targetId) return null;

      const targetById = document.getElementById(targetId);
      if (targetById) return targetById;

      const escapedTarget = targetId.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      return document.querySelector('[data-founder-story-target="' + escapedTarget + '"]');
    };

    const getTargetScrollTop = (target) => {
      const headerOffset = mobileQuery.matches ? 64 : 88;
      return Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset);
    };

    const scrollToStory = (target) => {
      window.scrollTo({
        top: getTargetScrollTop(target),
        behavior: reduceMotionQuery.matches ? "auto" : "smooth"
      });
      updateHash(target);
    };

    const syncFoldedStoryState = (target) => {
      if (isDesignMode) return;
      if (!target || target.dataset.hiddenUntilTrigger !== "true") return;

      const isVisible = target.classList.contains("is-visible");
      target.setAttribute("aria-expanded", isVisible ? "true" : "false");

      if (isVisible) {
        target.removeAttribute("role");
        target.removeAttribute("tabindex");
        return;
      }

      target.setAttribute("role", "button");
      target.setAttribute("tabindex", "0");
    };

    const syncFoldedStories = (root = document) => {
      const selector = '[data-founder-story][data-hidden-until-trigger="true"]';

      if (root.matches && root.matches(selector)) {
        syncFoldedStoryState(root);
      }

      root.querySelectorAll(selector).forEach(syncFoldedStoryState);
    };

    const collapseOtherStories = (activeTarget) => {
  if (isDesignMode) return;

  document
    .querySelectorAll('[data-founder-story][data-hidden-until-trigger="true"]')
    .forEach((story) => {
      if (story === activeTarget) return;

      story.classList.remove("is-visible");
      story.classList.remove("is-revealing");
      syncFoldedStoryState(story);
    });
};

const revealStory = (target) => {
  if (isDesignMode) return false;
  if (!target || target.dataset.hiddenUntilTrigger !== "true") return false;

  collapseOtherStories(target);

  if (target.classList.contains("is-visible")) return false;

  target.classList.add("is-visible");
  syncFoldedStoryState(target);

  if (!reduceMotionQuery.matches) {
    target.classList.add("is-revealing");
    window.setTimeout(() => {
      target.classList.remove("is-revealing");
    }, 800);
  }

  return true;
};

    const revealFoldedStory = (target) => {
      if (!revealStory(target)) return;
      scrollToStory(target);
    };

    const animateCardToStory = (card, target) => {
      const sourceImage = card.querySelector(".sfny-story-card__image, .sfny-story-card__placeholder");
      const targetMedia = target.querySelector("[data-founder-story-media]");
      const hideMobileImage = mobileQuery.matches && target.dataset.showMobileImage !== "true";

      if (!sourceImage || !targetMedia || hideMobileImage || reduceMotionQuery.matches || !sourceImage.animate) {
        scrollToStory(target);
        return;
      }

      const startRect = sourceImage.getBoundingClientRect();
      const targetScrollTop = getTargetScrollTop(target);
      const mediaRect = targetMedia.getBoundingClientRect();

      if (mediaRect.width < 1 || mediaRect.height < 1) {
        scrollToStory(target);
        return;
      }

      const endTop = window.scrollY + mediaRect.top - targetScrollTop;
      const sourceStyles = window.getComputedStyle(sourceImage);
      const targetStyles = window.getComputedStyle(targetMedia);
      const clone = sourceImage.cloneNode(true);

      clone.classList.add("sfny-story-image-clone");
      Object.assign(clone.style, {
        position: "fixed",
        left: startRect.left + "px",
        top: startRect.top + "px",
        width: startRect.width + "px",
        height: startRect.height + "px",
        margin: "0",
        zIndex: "9999",
        objectFit: sourceStyles.objectFit || "cover",
        borderRadius: window.getComputedStyle(card).borderRadius,
        filter: "grayscale(0%) brightness(0.98) contrast(1.02)",
        opacity: "0.98",
        transform: "scale(1)",
        pointerEvents: "none"
      });

      document.body.appendChild(clone);
      window.scrollTo({ top: targetScrollTop, behavior: "smooth" });
      updateHash(target);

      const finish = () => {
        clone.remove();
      };

      window.requestAnimationFrame(() => {
        const animation = clone.animate(
          [
            {
              left: startRect.left + "px",
              top: startRect.top + "px",
              width: startRect.width + "px",
              height: startRect.height + "px",
              borderRadius: window.getComputedStyle(card).borderRadius,
              opacity: 0.98,
              transform: "scale(1)"
            },
            {
              left: mediaRect.left + "px",
              top: endTop + "px",
              width: mediaRect.width + "px",
              height: mediaRect.height + "px",
              borderRadius: targetStyles.borderRadius || "20px",
              opacity: 1,
              transform: "scale(1.01)"
            }
          ],
          {
            duration: 820,
            easing: "cubic-bezier(0.16, 1, 0.3, 1)",
            fill: "forwards"
          }
        );

        if (animation.finished) {
          animation.finished.then(finish).catch(finish);
        } else {
          window.setTimeout(finish, 840);
        }
      });
    };

    const handleStoryTransition = (event, card) => {
      const targetId = getStoryTargetId(card);
      const target = findStoryTarget(targetId);

      if (!target) return false;

      event.preventDefault();
      revealStory(target);
      animateCardToStory(card, target);
      return true;
    };

    const revealStoryFromHash = () => {
      const targetId = window.location.hash.replace(/^#/, "");
      const target = findStoryTarget(targetId);

      if (!target) return;

      revealStory(target);
      scrollToStory(target);
    };

    const wrapIndex = (index, total) => {
      if (total === 0) return 0;
      return (index + total) % total;
    };

    const setActiveCard = (carousel, cards, activeIndex) => {
      const total = cards.length;
      carousel.dataset.activeCard = String(activeIndex);

      cards.forEach((card, index) => {
        const offset = wrapIndex(index - activeIndex, total);
        let position = "hidden";

        if (index === activeIndex) {
          position = "active";
        } else if (offset === 1) {
          position = "before";
        } else if (offset === total - 1) {
          position = "after";
        }

        card.dataset.storyPosition = position;
        card.setAttribute("aria-current", position === "active" ? "true" : "false");
      });
    };

    const initStoryCarousel = (carousel) => {
      if (carousel.dataset.storyCarouselInitialized === "true") return;

      const cards = Array.from(carousel.querySelectorAll("[data-story-card]"));
      if (cards.length < 2) return;

      carousel.dataset.storyCarouselInitialized = "true";

      let activeIndex = wrapIndex(Number(carousel.dataset.activeCard || 0), cards.length);
      let startX = 0;
      let startY = 0;
      let tracking = false;
      let didSwipe = false;

      setActiveCard(carousel, cards, activeIndex);

      const activate = (index) => {
        activeIndex = wrapIndex(index, cards.length);
        setActiveCard(carousel, cards, activeIndex);
      };

      cards.forEach((card, index) => {
        card.addEventListener("click", (event) => {
          if (mobileQuery.matches) {
            if (didSwipe) {
              event.preventDefault();
              event.stopPropagation();
              didSwipe = false;
              return;
            }

            if (index !== activeIndex) {
              event.preventDefault();
              activate(index);
              return;
            }
          }

          handleStoryTransition(event, card);
        });

        card.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;

          if (mobileQuery.matches && index !== activeIndex) {
            event.preventDefault();
            activate(index);
            return;
          }

          handleStoryTransition(event, card);
        });
      });

      carousel.addEventListener("pointerdown", (event) => {
        if (!mobileQuery.matches) return;
        tracking = true;
        didSwipe = false;
        startX = event.clientX;
        startY = event.clientY;

        if (carousel.setPointerCapture) {
          carousel.setPointerCapture(event.pointerId);
        }
      });

      carousel.addEventListener("pointerup", (event) => {
        if (!tracking || !mobileQuery.matches) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        tracking = false;

        if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

        didSwipe = true;

        if (deltaX < 0) {
          activate(activeIndex - 1);
        } else {
          activate(activeIndex + 1);
        }
      });

      carousel.addEventListener("pointercancel", () => {
        tracking = false;
      });
    };

    document.querySelectorAll("[data-story-cards-carousel]").forEach(initStoryCarousel);
    syncFoldedStories();
    revealStoryFromHash();

    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll("[data-story-cards-carousel]").forEach(initStoryCarousel);
      syncFoldedStories(event.target);
    });

    document.addEventListener("click", (event) => {
      const target = event.target.closest('[data-founder-story][data-hidden-until-trigger="true"]');

      if (!target || target.classList.contains("is-visible")) return;
      if (event.target.closest("a, button, input, select, textarea")) return;

      revealFoldedStory(target);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      const target = event.target.closest('[data-founder-story][data-hidden-until-trigger="true"]');
      if (!target || target.classList.contains("is-visible")) return;

      event.preventDefault();
      revealFoldedStory(target);
    });

    window.addEventListener("hashchange", revealStoryFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  if (!customElements.get('sfny-cart-shipping-celebration')) {
    customElements.define('sfny-cart-shipping-celebration', class extends HTMLElement {
      connectedCallback() {
        this.cartItems = this.previousElementSibling;
        if (!this.cartItems?.matches('cart-items')) return;

        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (this.motionPreference.matches) this.clearConfetti();
        };
        this.motionPreference.addEventListener('change', this.onMotionChange);
        this.wasQualified = this.isQualified();
        this.observer = new MutationObserver(() => {
          const qualified = this.isQualified();
          const crossedThreshold = qualified && !this.wasQualified;
          this.wasQualified = qualified;

          if (!qualified) this.clearConfetti();
          if (crossedThreshold) this.celebrate();
        });
        this.observer.observe(this.cartItems, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.motionPreference?.removeEventListener('change', this.onMotionChange);
        this.clearConfetti();
      }

      isQualified() {
        return Boolean(this.cartItems.querySelector('.cart-page__free-shipping--qualified'));
      }

      clearConfetti() {
        window.clearTimeout(this.cleanupTimer);
        this.querySelectorAll('span').forEach((particle) => {
          particle.getAnimations().forEach((animation) => animation.cancel());
        });
        this.replaceChildren();
      }

      celebrate() {
        if (this.motionPreference.matches || document.hidden || !Element.prototype.animate) return;

        const bar = this.cartItems.querySelector('.cart-page__free-shipping-track');
        if (!bar) return;

        this.clearConfetti();
        const rect = bar.getBoundingClientRect();
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        const y = Math.max(100, Math.min(height - 100, rect.top));
        const edgePadding = Math.max(16, width * 0.035);
        const spread = Math.min(90, width * 0.12);
        const colors = ['#b9a477', '#d8cdb7', '#aaa69f', '#484641'];
        const count = width < 750 ? 20 : 32;

        for (let index = 0; index < count; index += 1) {
          const particle = document.createElement('span');
          const x = edgePadding + ((index + 0.2 + Math.random() * 0.6) / count) * (width - edgePadding * 2);
          const targetX = Math.max(edgePadding, Math.min(width - edgePadding, x + (Math.random() * 2 - 1) * spread));
          const drift = targetX - x;
          const lift = 30 + Math.random() * 45;
          const fall = 120 + Math.random() * 80;
          const rotation = Math.random() * 240 - 120;
          particle.style.left = `${x}px`;
          particle.style.top = `${y - 35 + Math.random() * 70}px`;
          particle.style.backgroundColor = colors[index % colors.length];
          this.appendChild(particle);
          particle.animate([
            { transform: `translate(0, 0) rotate(${rotation * 0.5}deg)`, opacity: 0 },
            { transform: `translate(${drift * 0.3}px, ${-lift}px) rotate(${rotation}deg)`, opacity: 0.9, offset: 0.22 },
            { transform: `translate(${drift * 0.7}px, ${fall * 0.35}px) rotate(${rotation * 1.5}deg)`, opacity: 0.8, offset: 0.65 },
            { transform: `translate(${drift}px, ${fall}px) rotate(${rotation * 2}deg)`, opacity: 0 }
          ], {
            duration: 1800 + Math.random() * 400,
            easing: 'linear',
            fill: 'none'
          });
        }

        this.cleanupTimer = window.setTimeout(() => this.clearConfetti(), 2250);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-board"] && !Shopify.designMode) return;
  try {
    
  class MoodBoardSection extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.mood-card'));
      this.chips = Array.from(this.querySelectorAll('.mood-chip'));
      this.status = this.querySelector('[data-mood-status]');

      this.cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          const target = event.target;

          if (target instanceof Element && target.closest('a, button, input, form, product-form')) return;
          if (card.dataset.productUrl) window.location.href = card.dataset.productUrl;
        });

        card.addEventListener('mouseenter', () => this.previewCategory(card.dataset.category));
        card.addEventListener('mouseleave', () => this.clearCategoryPreview());
        card.addEventListener('focusin', () => this.previewCategory(card.dataset.category));
        card.addEventListener('focusout', (event) => {
          if (!card.contains(event.relatedTarget)) this.clearCategoryPreview();
        });

      });

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.selectCategory(chip);
        });
      });

    }

    setActiveCard(activeCard) {
      this.cards.forEach((card) => {
        const selected = card === activeCard;
        card.classList.toggle('is-active', selected);
      });
    }

    previewCategory(category) {
      this.chips.forEach((chip) => {
        chip.classList.toggle('is-preview', chip.dataset.target === category);
      });
    }

    clearCategoryPreview() {
      this.chips.forEach((chip) => chip.classList.remove('is-preview'));
    }

    selectCategory(activeChip) {
      const requestedCategory = activeChip.dataset.target;
      const resetToAll = requestedCategory === 'all' || activeChip.classList.contains('is-active');
      const category = resetToAll ? 'all' : requestedCategory;
      const selectedChip = this.chips.find((chip) => chip.dataset.target === category);
      const matches = category === 'all'
        ? this.cards
        : this.cards.filter((card) => card.dataset.category === category);

      this.chips.forEach((chip) => {
        const selected = chip === selectedChip;
        chip.classList.toggle('is-active', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const isMatch = matches.includes(card);
        card.classList.toggle('is-category-match', category !== 'all' && isMatch);
        card.classList.toggle('is-category-muted', category !== 'all' && !isMatch);
      });

      const openCard = this.cards.find((card) => card.classList.contains('is-active'));
      if (category !== 'all' && openCard && !matches.includes(openCard)) this.setActiveCard(null);

      if (category !== 'all' && matches.length) {
        const firstMatch = matches[0];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.setActiveCard(firstMatch);
        firstMatch.classList.remove('is-category-pop');
        void firstMatch.offsetWidth;
        firstMatch.classList.add('is-category-pop');
        firstMatch.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }

      if (this.status) {
        const label = selectedChip.textContent.replace(/\s+/g, ' ').trim();
        const names = matches.map((card) => card.dataset.productName).join(', ');
        this.status.textContent = category === 'all' ? 'All scents shown.' : `${label} scents emphasized: ${names}.`;
      }
    }
  }

  if (!customElements.get('mood-board-section')) {
    customElements.define('mood-board-section', MoodBoardSection);
  }

  } catch(e) { console.error(e); }
})();
})();
